import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-not-authorized',
  templateUrl: 'not-authorized-component.html',
  styleUrls: ['not-authorized.component.scss']
})
export class NotAuthorizedComponent implements OnInit {

  constructor() {
    // TODO document why this constructor is empty

  }

  ngOnInit(): void {
    // TODO document why this method 'ngOnInit' is empty

  }

}
